import { render, staticRenderFns } from "./coin-details.vue?vue&type=template&id=fa88a736&scoped=true&"
import script from "./coin-details.vue?vue&type=script&lang=js&"
export * from "./coin-details.vue?vue&type=script&lang=js&"
import style0 from "./coin-details.vue?vue&type=style&index=0&id=fa88a736&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa88a736",
  null
  
)

export default component.exports